import { Component, Event, EventEmitter, h, Listen, Prop, State } from '@stencil/core'
import { toUpper } from 'lodash-es'
import { DreamtenSvgIcon12 } from 'src/dreamten/svg_icon/svg_icon'
import { classes } from 'src/utils/css'

import { displayLanguage, getFlagAndAbbreviation } from './utils'

@Component({
  tag: 'call-select-translation',
})
export class PageCallDetailAiNotesSelectLanguage {
  @Event() selected: EventEmitter<string>

  @Prop() languages: string[]
  @Prop() selectedLanguage: string
  @Prop() isDisabled = false

  @State() isOpen = false

  @Listen('mousedown', { target: 'window' })
  onWindowClick() {
    this.isOpen = false
  }

  render() {
    const textColorClasses = this.isDisabled ? 'text-gray-70' : 'text-white'
    const selectedFlagAndAbbreviation = getFlagAndAbbreviation(this.selectedLanguage)

    return (
      <div class='flex relative items-stretch' onMouseDown={(e) => e.stopImmediatePropagation()}>
        <button
          type='button'
          onClick={() => {
            this.isOpen = !this.isOpen
          }}
          class={`
            inline-flex gap-5px justify-center items-center px-12px pt-7px pb-6px rounded-36px
            ${classes(this.isOpen, 'bg-gray-800')}
            border-1 border-gray-100
            ${classes(this.isDisabled, 'cursor-default')}
          `}
          disabled={this.isDisabled}
        >
          <span
            style={{ 'padding-top': '1px', 'padding-bottom': '1px' }}
            class={`text-small font-semibold ${textColorClasses}`}
          >
            <span class='mr-1'>{selectedFlagAndAbbreviation.icon}</span>
            <span>{toUpper(selectedFlagAndAbbreviation.code)}</span>
          </span>
          <DreamtenSvgIcon12 name='angle-down' class='text-gray-70' />
        </button>
        <div
          class={`
            absolute z-10 pl-10px py-10px rounded-md border-1 border-gray-700 bg-gray-800 shadow-dropdown justify-end items-center gap-4px w-36 left-0
            ${this.isOpen ? '' : 'hidden'}
          `}
        >
          <div class='flex overflow-y-hidden flex-col flex-grow'>
            <ui-scrollarea
              shadowColor='transparent'
              shadowStyleY={{ display: 'none' }}
              overflowX={false}
              style={{ maxHeight: '393px' }}
            >
              {this.languages.map((language: string) => {
                const isSelected = language === this.selectedLanguage
                return (
                  <div
                    class={`group flex gap-10px items-center self-stretch py-7px px-6px mr-10px ${classes(
                      !isSelected,
                      'hover:bg-brand-base hover:bg-opacity-20 cursor-pointer'
                    )} rounded-md`}
                    onClick={() => {
                      this.selected.emit(language)
                      this.isOpen = false
                    }}
                  >
                    <div class='flex flex-col gap-3px items-start'>
                      <div
                        class={`flex items-center spacing-x-6px text-large font-semibold text-gray-10 ${classes(
                          !isSelected,
                          'group-hover:text-brand-base'
                        )}`}
                      >
                        <span>{getFlagAndAbbreviation(language).icon}</span>
                        <span>{displayLanguage(language)}</span>
                      </div>
                    </div>
                  </div>
                )
              })}
            </ui-scrollarea>
          </div>
        </div>
      </div>
    )
  }
}
